import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import SplitPane from "react-split-pane";
import UpdateCorierMetadata from "./UpdateCorierMetadata";
import { useParams } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import Swal from "sweetalert2";
import DeletedCorierMetadata from "./DeletedCorierMetadata";
import CorierMetadataProperties from "../CorierMetadataProperties/CorierMetadataProperties";
import CorierMetadataActivities from "../CorierMetadataProperties/CorierMetadataActivities";
import { studyOnboardingService } from "../../../../../APIServices/studyOnboarding";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import UseToggle from "../../../../../Hooks/UseToggle";
import AddCorierMetadataForm from "./AddCorierMetadataForm";
import Pagination from "../../../../Pagination";
import { eiwrsCorierManagementServices } from "../../../../../APIServices/EIWRS/ShipmentManagement/eiwrsCorierManagementServices";

const CorierMetadataDataList = ({ onMouseDown, tableRef }) => {
  const [searchData, setSearchData] = useState("");
  const [columnData, setColumnData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [corierColumns, setCorierColumns] = useState([]);
  const [corierColumnsCount, setCorierColumnsCount] = useState(0);
  const [corierDeletedColumns, setCorierDeletedColumns] = useState([]);
  const [corierDeletedColumnsCount, setCorierDeletedColumnsCount] = useState(0);
  const { toggle, setToggle, toggle1, setToggle1 } = UseToggle();
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const [activeTab, setActiveTab] = useState("properties");
  const [activityLoader, setActivityLoader] = useState(false);
  const [columnId, setColumnId] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [corierActivity, setCorierActivity] = useState([]);
  const [corierActivityCount, setCorierActivityCount] = useState(0);
  const [isFormOpen, setIsFormOpen] = useState(false);

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(corierColumnsCount / itemsPerPage);

  const getStudyCorierColumnData = async (e) => {
    setLoading(true);
    let data = await eiwrsCorierManagementServices.getStudyCorierColumnData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setCorierColumns(data?.data || []);
    setCorierColumnsCount(data?.count || 0);
    setColumnData("");
    setColumnId("");
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudyCorierColumnData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsCorierManagementServices.getStudyCorierColumnData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setCorierDeletedColumns(data?.data || []);
    setCorierDeletedColumnsCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "corierMetadata",
      studyId,
      columnData?.columnId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setCorierActivity(data?.data || []);
    setCorierActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const softDeleteRestoreStudyCorierColumn = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} corier metadata!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.type = type;
        let data =
          await eiwrsCorierManagementServices.softDeleteRestoreStudyCorierColumn(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyCorierColumnData();
          getDeletedStudyCorierColumnData();
          if (type === "restore") {
            getDeletedStudyCorierColumnData(
              pageNumberDeleted,
              itemsPerPageDeleted
            );
            setToggle1();
          }
        }
      }
    });
  };

  useEffect(() => {
    getStudyCorierColumnData();
  }, [searchData, pageNumber, itemsPerPage]);

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add Corier Metadata"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setColumnId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          <div className="vr"></div>
          {corierColumnsCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        {corierDeletedColumnsCount > 0 &&
          <button
            onClick={() => {
              setToggle1();
              getDeletedStudyCorierColumnData(
                pageNumberDeleted,
                itemsPerPageDeleted
              );
            }}
            className={`updateProfile`}
          >
            Deleted History
          </button>
        }
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={columnId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddCorierMetadataForm
              getStudyCorierColumnData={getStudyCorierColumnData}
            />
          )}
          {loading ? (
            <PageLoader />
          ) : corierColumnsCount === 0 ? (
            <NoDataFoundTable MSG={"Corier Metadata list not found!"} />
          ) : corierColumns?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Corier Metadata list not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Column Label</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Column Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Column Type</th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>
                      Column Option
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 5)}>Required</th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 6)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 7)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {corierColumns?.map((column, index) => (
                    <tr
                      key={index}
                      className={`${column?.type !== "predefine" && "CP"} ${columnId === column?._id ? "highlighted" : ""
                        }`}
                      onClick={() => {
                        setIsFormOpen(false);
                        if (column?.type !== "predefine") {
                          setColumnData(column);
                          setColumnId(column?._id);
                        }
                      }}
                      title="View Details"
                    >
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>{column?.columnLabel}</td>
                      <td>{column?.columnName}</td>
                      <td>{column?.columnType}</td>
                      <td>
                        {(column?.columnOption || [])
                          .map((item) => item.option)
                          .join(", ")}
                      </td>
                      <td className="text-capitalize">{column?.required}</td>
                      <td
                        className="text-center"
                        title={`Update ${column?.columnLabel}`}
                        onClick={(e) => {
                          if (column?.type !== "predefine") {
                            setColumnData(column);
                            setToggle();
                          }
                          e.stopPropagation();
                        }}
                        style={{
                          cursor:
                            column?.type !== "predefine"
                              ? "pointer"
                              : "no-drop",
                        }}
                      >
                        <FaEdit className="text-muted" />
                      </td>
                      <td
                        className="text-center"
                        title={`Delete ${column?.columnLabel}`}
                        onClick={(e) => {
                          if (column?.type !== "predefine") {
                            softDeleteRestoreStudyCorierColumn(
                              column?._id,
                              "delete"
                            );
                          }
                          e.stopPropagation();
                        }}
                        style={{
                          cursor:
                            column?.type !== "predefine"
                              ? "pointer"
                              : "no-drop",
                        }}
                      >
                        <FaTrash
                          className={
                            column?.type !== "predefine"
                              ? "text-danger"
                              : "text-muted"
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={corierColumnsCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {columnId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["properties", "activities"].map((tab) => (
                  <button
                    key={tab}
                    className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                      }`}
                    onClick={() => setActiveTab(tab)}
                    title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setColumnId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "properties" && (
              <CorierMetadataProperties
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                columnData={columnData}
              />
            )}
            {activeTab === "activities" && (
              <CorierMetadataActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                corierActivity={corierActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                columnData={columnData}
                corierActivityCount={corierActivityCount}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateCorierMetadata
        Show={!toggle}
        Hide={setToggle}
        columnData={columnData}
        getStudyCorierColumnData={getStudyCorierColumnData}
        Title={"Update Corier Metadata"}
      />
      <DeletedCorierMetadata
        Show={!toggle1}
        Hide={setToggle1}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        corierDeletedColumns={corierDeletedColumns}
        getDeletedStudyCorierColumnData={getDeletedStudyCorierColumnData}
        corierDeletedColumnsCount={corierDeletedColumnsCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudyCorierColumn={
          softDeleteRestoreStudyCorierColumn
        }
        Title={"Deleted Corier Metadata History"}
      />
    </>
  );
};

export default CorierMetadataDataList;
